module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Eraser-70ca8bcff31c5b16d460e21ff5dbde7f.svg";